<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).on('click',"a.tab-title[href='#tab-review']",function(){
 alert('ss');
    $('div#shopify-block-judge_me_reviews_review_widget_wHCemg ').show();
  });

// $(document).on('click','.checkbox-area input[type=checkbox], .checkbox-area label',function() {
//   if ($('.checkbox-area input[type=checkbox]').is(':checked')) {
//     $('.custom-qtybox quantity-input').removeClass('hidden');
//     $('.add-on input.custom-input').attr('name','items[1][id]');
//     $('.add-on input.addon-product').attr('name','items[1][quantity]');
//     } else {
//     $('.custom-qtybox quantity-input').addClass('hidden');
//     $('.add-on input.custom-input').removeAttr('name');
//     $('.add-on input.addon-product').removeAttr('name');
//                 }
// });

// $(document).on('click','.checkbox-area label',function() {
//   console.log('label click');
//   if ($('.checkbox-area input[type=checkbox]').is(':checked')) {
//     console.log('checked');
//     $('.checkbox-area input[type=checkbox]').removeAttr('checked');
//     $('.custom-qtybox quantity-input').addClass('hidden');
//     $('.add-on input.custom-input').removeAttr('name');
//     $('.add-on input.addon-product').removeAttr('name');    
//                 } 
//   else {
//     console.log('not checked');
//     $('.checkbox-area input[type=checkbox]').attr('checked','checked');
//     $('.custom-qtybox quantity-input').removeClass('hidden');
//     $('.add-on input.custom-input').attr('name','items[1][id]');
//     $('.add-on input.addon-product').attr('name','items[1][quantity]');
//                 }
// });

var nofind=setInterval(function(){
 var dataval_exsist=$(".spb-productdescfont").hasClass('spb-productdesctextcolor');
  //console.log(dataval_exsist);
  if(dataval_exsist == true){
      var dataval=$("#infiniteoptions-container div:nth-child(2)").find('option:selected').val();
        if (dataval== 'No') {
        $('.custom-qtybox').hide();
        }
   clearInterval(nofind);
}

},100); 


$(document).on('click','.custom-qtybox button[name="plus"], .custom-qtybox button[name="minus"]',function() {
var qty_val = $('.custom-qtybox .quantity__input').val();
    $('.add-on.two input.addon-product').val(qty_val);
    $('.add-on.three .addon-product_1').val(qty_val);
    $('.add-on.three .addon-product_2').val(qty_val);
});


$(document).on('keyup','.custom-qtybox .quantity__input',function() {
    var qty_val = $(this).val();
    $('.add-on.two input.addon-product').val(qty_val);
    $('.add-on.three .addon-product_1').val(qty_val);
    $('.add-on.three .addon-product_2').val(qty_val);
});


$(document).on('keyup','.custom-qtybox-three .first-option .quantity__input',function() {
    var qty = $(this).val();
 
   $('.add-on.three .addon-product_1').val(qty);
  
});
$(document).on('keyup','.custom-qtybox-three .second-option .quantity__input',function() {
    var qty = $(this).val();
   
    $('.add-on.three .addon-product_2').val(qty);
});
$(document).on('click','.custom-qtybox-three .first-option button[name="plus"], .custom-qtybox-three .first-option button[name="minus"]',function() {
 var qty=$(this).closest('.quantity__container').find('.quantity__input').val();
 $('.add-on.three .addon-product_1').val(qty);
  
});

$(document).on('click','.custom-qtybox-three .second-option button[name="plus"], .custom-qtybox-three .second-option button[name="minus"]',function() {
 var qty=$(this).closest('.quantity__container').find('.quantity__input').val();
$('.add-on.three .addon-product_2').val(qty);
});


$(document).on('change', ".gpo-container .gpo-app div[data-element-id='dropdown-1'] input[type='radio']", function() {
    // Log the element that triggered the event
    console.log('Changed element:', this);
    
    var dataval = $('.show-addon-for-option[data-element-id="dropdown-1"] .gpo-selected-values').text();
    // alert(dataval);

    if (dataval === 'Yes') {
        // Update text for the third element
        $('.show-addon-for-option[data-element-id="dropdown-2"] .gpo-selected-values')
            .addClass('has-value')
            .text('Additional AAC Elite Athlete');

        // Set text for the nested element, if exists
        $('.show-addon-for-option[data-element-id="dropdown-2"] .gpo-dropdown .dropdown-button .dropdown-button__value')
            .text('Additional AAC Elite Athlete');
        
        // Select "Additional AAC Elite Athlete" in dropdown-2
        $('.show-addon-for-option[data-element-id="dropdown-2"] .dropdown-list input[type="radio"][value="Additional AAC Elite Athlete"]').prop('checked', true).trigger('change');

        // Show elements
        $('.custom-qtybox').css('display', 'block');
        $('.checkbox-area').removeClass('hidden').show();
        $('.custom-qtybox .productView-quantity').removeClass('hidden').show();

        // Update names and text based on conditions
        if ($('.show-addon-for-option[data-element-id="dropdown-2"] .gpo-selected-values').text() === "Additional AAC Elite Athlete") {
            var price = $('.product_1_price').val();
            $('label[for="additional-member"] span').text(price);
            $('.add-on.three .sub_id1').attr('name', 'items[1][selling_plan]');
            $('.add-on.three .custom_input_1').attr('name', 'items[1][id]');
            $('.add-on.three .addon-product_1').attr('name', 'items[1][quantity]');
            $('.memberadd h3').text("Additional AAC Elite Athlete");
        }

        $('.custom-qtybox .quantity-input').removeClass('hidden');

        // Reset names for second option
        $('.add-on.two .sub_id1').removeAttr('name');
        $('.add-on.two .custom-input').attr('name', 'items[1][id]');
        $('.add-on.two input.addon-product').attr('name', 'items[1][quantity]');
        $('.add-on.two .sub_id1').attr('name', 'items[1][selling_plan]');
    } else {
        // Hide elements and reset
        $('.custom-qtybox .quantity-input').addClass('hidden');
        $('.second-option .quantity-input').addClass('hidden');
        $('.checkbox-area').addClass('hidden');
        $('.add-on input').removeAttr('name');
        $('.custom-qtybox').hide();
        $('.custom-qtybox-three').hide();
    }
});




$(document).on('change', ".gpo-container .gpo-app div[data-element-id='dropdown-2'] input[type='radio']", function() {
    var dataval = $('.show-addon-for-option[data-element-id="dropdown-1"] .gpo-selected-values').text().trim();

    // Get selected value from dropdown-2
    var selectedValue = $('.gpo-container .gpo-app div[data-element-id="dropdown-2"] input[type="radio"]:checked').val();

    if (dataval === 'Yes') {
        if (selectedValue === "Additional AAC Elite Athlete") {
            var price = $('.product_1_price').val();
            $('.custom-qtybox-three').hide();
            $('.custom-qtybox').show();
            $('.custom-qtybox-three .productView-quantity').addClass('hidden');
            $('label[for="additional-member"] span').text(price);

            $('.custom-qtybox .quantity-input').removeClass('hidden');
            $('.checkbox-area').removeClass('hidden');

            $('.add-on.three .custom_input_2').removeAttr('name');
            $('.add-on.three .addon-product_2').removeAttr('name');
            $('.add-on.three .sub_id1').removeAttr('name');
            $('.add-on.three .sub_id1').attr('name', 'items[1][selling_plan]');
            $('.add-on.three .custom_input_1').attr('name', 'items[1][id]');
            $('.add-on.three .addon-product_1').attr('name', 'items[1][quantity]');
            $('.add-on.three .addon-product_1').val(1);
            $('.add-on.three .addon-product_2').val(1);
            $('.custom-qtybox .quantity__input').val(1);
            $('.memberadd h3').text("Additional AAC Elite Athlete");
            $('.common-chkbox').show();
        } else if (selectedValue === "Immediate Family Platinum Member") {
            $('.common-chkbox').show();
            $('.memberadd h3').text("Immediate Family Platinum Member");
            var price = $('.product_2_price').val();
            $('.custom-qtybox-three').hide();
            $('.custom-qtybox').show();
            $('.custom-qtybox-three .productView-quantity').addClass('hidden');
            $('label[for="additional-member"] span').text(price);

            $('.custom-qtybox .quantity-input').removeClass('hidden');
            $('.checkbox-area').removeClass('hidden');

            $('.add-on.three .custom_input_1').removeAttr('name');
            $('.add-on.three .addon-product_1').removeAttr('name');
            $('.add-on.three .sub_id1').removeAttr('name');
            $('.add-on.three .sub_id1').attr('name', 'items[1][selling_plan]');
            $('.add-on.three .custom_input_2').attr('name', 'items[1][id]');
            $('.add-on.three .addon-product_2').attr('name', 'items[1][quantity]');
            $('.add-on.three .addon-product_1').val(1);
            $('.add-on.three .addon-product_2').val(1);
            $('.custom-qtybox .quantity__input').val(1);
        } else {
            $('.common-chkbox').hide();
            $('.custom-qtybox .quantity-input').addClass('hidden');

            function extractPrice(value) {
                return parseFloat(value.replace('$', ''));
            }

            var price1 = extractPrice($('.product_1_price').val());
            var price2 = extractPrice($('.product_2_price').val());
            var sumPrices = price1 + price2;

            $('.custom-qtybox-three').show();
            $('.custom-qtybox').hide();
            $('.custom-qtybox-three .productView-quantity').removeClass('hidden');
            $('.first-option .memberadd h3').text("Additional AAC Elite Athlete");
            $('.first-option .memberadd span').text('(+$' + price1.toFixed(2) + ')');
            $('.second-option .memberadd h3').text("Immediate Family Platinum Member");
            $('.second-option .memberadd span').text('(+$' + price2.toFixed(2) + ')');
            $('.checkbox-area').removeClass('hidden');

            $('.add-on.three .sub_id1').removeAttr('name');
            $('.add-on.three .sub_id2').removeAttr('name');
            $('.add-on.three .sub_id1').attr('name', 'items[1][selling_plan]');
            $('.add-on.three .sub_id2').attr('name', 'items[2][selling_plan]');
            $('.add-on.three .custom_input_1').attr('name', 'items[1][id]');
            $('.add-on.three .addon-product_1').attr('name', 'items[1][quantity]');
            $('.add-on.three .custom_input_2').attr('name', 'items[2][id]');
            $('.add-on.three .addon-product_2').attr('name', 'items[2][quantity]');
            $('.add-on.three .addon-product_1').val(1);
            $('.add-on.three .addon-product_2').val(1);
        }
    } else {
        $('.custom-qtybox .quantity-input').addClass('hidden');
        $('.checkbox-area').addClass('hidden');
        $('.add-on.three input').removeAttr('name');
    }
});

 var additionalMember = document.getElementById('additional-member');
    if (additionalMember) {
        additionalMember.addEventListener('click', function(event) {
            event.preventDefault();
            this.checked = true;  
            this.disabled = true;   
        });
    }
 
// Smooth scrolling for anchor links - jQuery approach for better compatibility
$(document).ready(function() {
    // Handle smooth scrolling for anchor links
    $('a[href*="#"]:not([href="#"])').on('click', function(e) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var targetHash = this.hash;
            var target = $(targetHash);
            target = target.length ? target : $('[name=' + targetHash.slice(1) + ']');
            
            if (target.length) {
                e.preventDefault();
                
                // Calculate header height more accurately
                var headerHeight = 0;
                var header = $('.header-wrapper:visible').first();
                
                if (header.length) {
                    headerHeight = header.outerHeight();
                } else {
                    // Fallback header selectors
                    header = $('.site-header:visible, .shopify-section-header:visible, header:visible').first();
                    if (header.length) {
                        headerHeight = header.outerHeight();
                    }
                }
                
                // Add extra offset to ensure heading is visible
                var extraOffset = 50; // Increased offset to show heading properly
                var scrollPosition = target.offset().top - headerHeight - extraOffset;
                
                // Ensure we don't scroll past the top of the page
                if (scrollPosition < 0) scrollPosition = 0;
                
                // Animate scroll with jQuery
                $('html, body').animate({
                    scrollTop: scrollPosition
                }, 800, 'swing', function() {
                    // Update URL hash after scrolling
                    if (history.pushState) {
                        history.pushState(null, null, targetHash);
                    } else {
                        location.hash = targetHash;
                    }
                });
                
                return false;
            }
        }
    });
    
    // Also handle direct hash navigation on page load
    if (window.location.hash) {
        setTimeout(function() {
            var target = $(window.location.hash);
            if (target.length) {
                var headerHeight = $('.header-wrapper:visible').outerHeight() || 100;
                var scrollPosition = target.offset().top - headerHeight - 50;
                
                $('html, body').animate({
                    scrollTop: scrollPosition
                }, 800);
            }
        }, 100);
    }
});

